export default __webpack_public_path__ + "static/media/aws-certified-cloud-practitioner.af183159.png";